import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up'
}: FadeInProps) {
  const directionOffset = {
    up: 20,
    down: -20,
    left: 20,
    right: -20,
    none: 0
  };
  return <motion.div initial={{
    opacity: 0,
    y: direction === 'up' || direction === 'down' ? directionOffset[direction] : 0,
    x: direction === 'left' || direction === 'right' ? directionOffset[direction] : 0
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: delay,
    ease: 'easeOut'
  }} data-id="element-8">
      {children}
    </motion.div>;
}